import { useParams } from 'react-router';
import { Channels } from '$state/types/channels';

export const useTemplateParams = () =>
    useParams<{ channelName: Channels; templateId?: string }>();
